<template>
  <section
    class="page-container">
    <div class="flex-sb-center mg-b-30">
      <span class="title">Create Quote For</span>
      <v-button
        green
        @click="handleNext">Next</v-button>
    </div>
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <div class="flex">
        <div class='half flex-platform mg-r-15'>
          <file-list-container
            ref="upload-form"
            v-model="formData.fileList"
            is-multiple
            is-has-type
            drag></file-list-container>
        </div>
        <div class="flex-platform half mg-l-15">
          <div class="form-item width-335">
            <span>Source</span>
            <el-form-item
              ref="ref_agency_id"
              :rules="rules.select"
              prop="ref_agency_id">
              <v-select
                v-model="formData.ref_agency_id"
                :list="globalOptions.ref_agency"/>
            </el-form-item>
          </div>
          <el-form-item
            ref="select_type"
            :rules="rules.select"
            prop="select_type" >
            <v-radio-group
              v-model="formData.select_type"
              :list="serverTypeIcon"
              :disabled-list="[2]"
              button
            >
              <template v-slot:default="{item}">
                <span class="flex-align-center">
                  <span
                    v-if="item.id"
                    class="table-icon__img">
                    <img :src="getOptionName('serverTypeIcon',item.id)" >
                  </span>
                  <span
                    :class="{'color-white':item.id==formData.select_type}"
                    class="fs-16 mg-l-10 color-dark">{{item.type}}</span>
                </span>
              </template>
            </v-radio-group>
          </el-form-item>
          <el-form-item
            ref="product_id"
            :rules="rules.select"
            prop="product_id" >
            <div class="type-container mg-t-15">
              <div
                v-for="(item,index) in list"
                :key="index"
                :class="{'card__active':item.classId==formData.class_id}"
                class="type-box card"
                @click="typeClick(item)">
                <div class="img-container">
                  <div
                    :class="item.logo"
                    class="hbanner-def"></div>
                </div>
                <span class="type-label">{{ item.label }}</span>
              </div>
              <div
                v-for="(item, index) in smeList"
                :key="'sme'+index"
                :class="{'card__active':item.productId==formData.product_id}"
                class="type-box card"
                @click="typeClick(item,1)">
                <div class="icon-container">
                  <font-awesome-icon :icon="item.icon"></font-awesome-icon>
                </div>
                <span class="type-label">{{ item.label }}</span>
              </div>
              <div
                v-for="(item, index) in carList"
                :key="'car_'+index"
                :class="{'card__active':item.productId==formData.product_id}"
                class="type-box card"
                @click="typeClick(item,1)">
                <div class="icon-container">
                  <font-awesome-icon :icon="item.icon"></font-awesome-icon>
                </div>
                <span class="type-label">{{ item.label }}</span>
              </div>
            </div>
          </el-form-item>
        </div>
      </div>
    </el-form>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinSelectQuote from '@/mixins/select-quote'
import MixinFormat from '@/mixins/format'
import {mapActions} from 'vuex'
import {ocrFileDetail} from '@api/ocr'
import axios from 'axios'
export default {
  name: 'select-for-quote',
  components:{
  },
  mixins: [MixinOptions, MixinRules,MixinFormat,MixinSelectQuote],
  data(){
    return{
      formData:{
        product_id:'',
        class_id:'',
        fileList:[],
        type:'',
        select_type:1,
        ref_agency_id:'',
      },
      loading:false
    }
  },
  computed:{
    severType(){
      let {select_type} = this.formData||{}
      return select_type==1?'holdcover':'fina'
    },
    hasCustomer(){
      let {hasCustomer} = this.$route.query||{}
      return hasCustomer
    }
  },
  mounted() {
    this.setCreateQuoteForm(null)
  },
  methods:{
    ...mapActions('quote',['setCreateQuoteForm']),
    async handleNext(){
      let params = {}
      if(this.hasCustomer){
        params.hasCustomer  = true
      }
      let files = await this.$refs['upload-form'].submitForm()
      this.$refs.form.validate((valid, rules) => {
        if(valid){
          let params ={
            ...this.formData
          }
          let {fileList=[]} = this.formData||{}
          if(fileList.length<=0)
            this.handleConfirm()
          else {

            this.network().getOcrFileDetail(files)
            // this.$router.push({
            //   path:`/quoting/disc-upload/${this.severType}`
            // })
          }
          // this.handleConfirm()
        }else
          this.scrollToValidDom(rules)
      })
      // this.$router.push({
      //   path:`/quoting/${this.severType}/index`,
      //   query:{
      //     ...params
      //   }
      // })
    },
    handleConfirm(){
      let{type,product_id,class_id,ref_agency_id} = this.formData||{}
      let params ={
        source:ref_agency_id
      }
      if(type==1){
        this.$router.push(
          {
            path: `/create/sme/${this.severType}/tickets/${product_id}`,
            query:params
          }
        )
      }else {
        if(product_id==13){
          this.network().getQuoteAllNew({class_id: 22})
        }else {
          this.$router.push(
            {
              path: `/quoting/${this.severType}/underwriting`,
              query:params
            }
          )
        }
      }

    },
    network() {
      return {
        getOcrFileDetail: async params => {
          // this.loading = true
          // const {data} = await axios.post('/admin/ocr', params, {
          //   headers: {
          //     'Content-Type': 'multipart/form-data'
          //   }
          // }).catch(err=>{
          //   this.loading =false
          // })
          const {data} = await ocrFileDetail(params)
          let filesNeedEdit = false   // 需要编辑的文件
          data.filter((item)=>{
            let {ocr,async} =item||{}
            if (async === false && ocr||async === true) {
              filesNeedEdit = true
            }
          })
          this.setCreateQuoteForm({...this.formData,files:data})
          this.loading = false
          let{type,product_id,class_id,ref_agency_id} = this.formData||{}
          if(filesNeedEdit){
            this.$router.push({
              path:`/quoting/disc-upload/${this.severType}`
            })
          }else {
            this.handleConfirm()
          }
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container{
  padding: 30px 70px;
  .title{
    font-weight: 600;
    font-size: 36px;
    color: $dark;
  }
  .table-icon__img{
    width: 40px;
    height: 40px;
    display: block;
    img{
      width: 40px;
      height: 40px;
    }
  }
  .card{
    padding: 8px;
  }
  .hzmb{
    background-image: url("~@/assets/images/quote/hzmb.png");
    background-repeat: no-repeat;
    width: 68px;
    height: 68px;
    background-size: 68px 68px;
  }
  .hbanner-def{
    background-image: url("~@/assets/images/quote/productlist.png");
    background-repeat: no-repeat;
    width: 51px;
    height: 51px;
    background-size: 867px 51px;
    &.Motorcycle{
      background-position: -612px 0;
    }
    &.PrivateCar{
      background-position: -51px 0;
    }
    &.PersonlAccident{
      background-position: -102px 0;
    }
    &.Home{
      background-position: -561px 0;
    }
    &.Fire{
      background-position: -408px 0;
    }
    &.Housemaid{
      background-position: -714px 0;
    }
    &.Travel{
      background-position: -255px 0;
    }
    &.OverseasStudent{
      background-position: -357px 0;
    }
    &.WorkingHoliday{
      background-position: -204px 0;
    }
    &.CommercialVehicle{
      background-position: -510px 0;
    }
    &.InteriorDecoration{
      background-position: -663px 0;
    }
    &.DroneLiability{
      background-position: -459px 0;
    }
    &.ReturnShipment{
      background-position: -153px 0;
    }
    &.SportsPA{
      background-position: -306px 0;
    }
    &.Pet{
      background-position: -765px 0;
    }
    &.MotorTrade{
      background-position: -816px 0;
    }
  }
  .hzmb{
    background-image: url("~@/assets/images/quote/hzmb.png");
    background-repeat: no-repeat;
    width: 51px;
    height: 51px;
    background-size: 51px 51px;
  }
  .list-title{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #24292E;
    margin-top: 30px ;
    margin-bottom: 20px;
    display: inline-block;
  }
  .type-container {
    display: flex;
    flex-wrap: wrap;
    .type-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-right: 8px;
      margin-bottom: 8px;
      text-align: center;
      width: 140px;
      //height: 140px;
      cursor: pointer;
      border: 1px solid #D1D5DA;
      border-radius: 5px;
      box-shadow: none;
      .img-container {
        display: flex;
        align-items: center;
        justify-content: center;
        //margin-bottom: 5px;
        width: 120px;
        height: 51px;
        img {
          max-width: 120px;
          max-height: 51px;
        }
      }
      .icon-container{
        font-size: 51px;
        color: #6A737D;
      }
      .type-label {
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        color: #303133;
      }
      .type-container-span {
        padding-top: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        span:nth-of-type(2) {
          margin-left: 10px;
        }
      }
      .span-checkbox {
        display: inline-block;
        padding: 0 10px;
        height: 20px;
        line-height: 18px;
        color: #586069;
        font-size: 12px;
        border-radius: 100px;
        border: 1px solid #e1e4e8;
        background: #fff;
        word-wrap: none;
        white-space: nowrap;
        font-family: 'Inter';
        font-style: normal;
        font-weight: 600;
      }
    }
  }
  .half{
    flex: 1;
  }
  .color-white{
    color: #fff!important;
  }
  .card__active{
    background: #b3d9ff;
    border-color:#b3d9ff!important;
  }
  .width-335{
    width: 335px;
  }
  .table-icon__img{
    width: 40px;
    height: 40px;
    display: block;
    img{
      width: 40px;
      height: 40px;
    }
  }
  .card{
    padding: 8px;
  }
  .half{
    flex: 1;
  }
  .color-white{
    color: #fff!important;
  }
  .card__active{
    background: #b3d9ff;
    border-color:#b3d9ff!important;
  }
}

</style>
